import { IError } from "../types/errors.d";
import { ActionType } from "../types/store-types";

export enum UserRoles {
    ADMIN,
    MODERATOR,
    USER,
    GUEST,
}

export enum IUserTypes {
    GUEST = "GUEST",
    USER = "USER",
}

export interface IUser {
    _id: string;
    name: string;
    email: string;
    isActive: boolean;
    pic?: string | null;
    role: IUserTypes;
    createdAt: string;
    updatedAt: string;
}

/* - Data Types - */

/* -- Init user Request Data */

export interface IInitUserActivationRequestData {
    code: string | null;
}

export interface IInitUserActivationSuccessData {
    success: boolean;
    message: string;
    data: {
        _id: string;
        first_name: string;
        last_name: string;
        email: string;
        country: string;
        phone: string;
        pic: string;
        birthday: string;
        industry: string;
        gender: string;
        isActive: boolean;
        role: Array<number>;
        provider: Array<string>;
        platform: Array<string>;
        browser: string;
        location: string;
        logoutDt: string;
        createdAt: string;
        updatedAt: string;
    };
}

export interface IInitUserActivationFailureData extends IError {}

export interface IInitUserRequestData {}

export interface IInitUserSuccessData {
    token: string;
    refresh_token: string;
    userType: IUserTypes;
}

export interface IInitUserFailureData extends IError {}

/* -- Sign In user Request Data */

export interface ISignInRequestData {
    email: string;
    password: string;
}

export interface ISignInSuccessData {
    token: string;
    refresh_token: string;
}

export interface ISignInFailureData extends IError {}

/* -- Sign Up user Request Data */

export interface ISignUpRequestData {
    name: string;
    email: string;
    password: string;
    redirect_url: string;
}

export interface ISignUpSuccessData extends IUser {}

export interface ISignUpFailureData extends IError {}

/* -- Confirm user Request Data */

export interface IConfirmUserRequestData {
    code: string;
}

export interface IConfirmUserSuccessData {}

export interface IConfirmUserFailureData extends IError {}

export interface ISetUserToken {
    token: string;
    refresh_token: string;
    userType?: UserRoles;
}

export interface ISetLoadingData {
    isLoading: boolean;
}

/* Get Current User Data */
export interface IGetCurrentUserData {}

export interface IGetCurrentUserSuccess {
    first_name: string;
    last_name: string;
    email: string;
    role: UserRoles;
    pic: string | null;
    _id: string;
    isActive: boolean;
    createdAt: string;
    updatedAt: string;
}

/* Migrate user request data  */
export interface IMigrateGuestRequest {
    userId: string;
    userRefreshToken: string;
    formId: string;
}
export interface IMigrateGuestFailure {}
export interface IMigrateGuestSuccess {
    userId: string;
    userRefreshToken: string;
}

export interface IClearErrorsData {}

/* - State - */

export interface IAuthState {
    user: IUser | null;
    userType: IUserTypes;
    token: string | null;
    refresh_token: string | null;
    errors: null | IError;
    isLoading: boolean;
}

/* - Action Types - */

export enum AuthActionTypes {
    INIT_USER_REQUEST = "AUTH.INIT_USER_REQUEST",
    INIT_USER_SUCCESS = "AUTH.INIT_USER_SUCCESS",
    INIT_USER_FAILURE = "AUTH.INIT_USER_FAILURE",

    INIT_USER_ACTIVATION = "AUTH.INIT_USER_ACTIVATION",
    INIT_USER_ACTIVATION_SUCCESS = "AUTH.INIT_USER_ACTIVATION_SUCCESS",
    INIT_USER_ACTIVATION_FAILURE = "AUTH.INIT_USER_ACTIVATION_FAILURE",

    GET_CURRENT_USER_REQUEST = "AUTH.GET_CURRENT_USER_REQUEST",
    GET_CURRENT_USER_SUCCESS = "AUTH.GET_CURRENT_USER_SUCCESS",
    GET_CURRENT_USER_FAILURE = "AUTH.GET_CURRENT_USER_FAILURE",

    MIGRATE_GUEST_TO_USER_REQUEST = "AUTH.MIGRATE_GUEST_TO_USER_REQUEST",
    MIGRATE_GUEST_TO_USER_SUCCESS = "AUTH.MIGRATE_GUEST_TO_USER_SUCCESS",
    MIGRATE_GUEST_TO_USER_FAILURE = "AUTH.MIGRATE_GUEST_TO_USER_FAILURE",

    SET_USER_TOKEN = "AUTH.SET_USER_TOKEN",
    SET_LOADING = "AUTH.SET_LOADING",
    CLEAR_ERRORS = "AUTH.CLEAR_ERRORS",
}

/* - Action Interfaces  - */

export type InitUserActivationRequestActionType = ActionType<
    AuthActionTypes.INIT_USER_ACTIVATION,
    IInitUserActivationRequestData
>;
export type InitUserActivationSuccessActionType = ActionType<
    AuthActionTypes.INIT_USER_ACTIVATION_SUCCESS,
    IInitUserActivationSuccessData
>;
export type InitUserActivationFailureActionType = ActionType<
    AuthActionTypes.INIT_USER_ACTIVATION_FAILURE,
    IInitUserActivationFailureData
>;
export type InitUserRequestActionType = ActionType<AuthActionTypes.INIT_USER_REQUEST, IInitUserRequestData>;
export type InitUserSuccessActionType = ActionType<AuthActionTypes.INIT_USER_SUCCESS, IInitUserSuccessData>;
export type InitUserFailureActionType = ActionType<AuthActionTypes.INIT_USER_FAILURE, IInitUserFailureData>;

export type GetCurrentUserRequestActionType = ActionType<AuthActionTypes.GET_CURRENT_USER_REQUEST, IGetCurrentUserData>;
export type GetCurrentUserSuccessActionType = ActionType<
    AuthActionTypes.GET_CURRENT_USER_SUCCESS,
    IGetCurrentUserSuccess
>;
export type GetCurrentUserFailureActionType = ActionType<AuthActionTypes.GET_CURRENT_USER_FAILURE, IGetCurrentUserData>;

export type MigrateGuestToUserRequestActionType = ActionType<
    AuthActionTypes.MIGRATE_GUEST_TO_USER_REQUEST,
    IMigrateGuestRequest
>;
export type MigrateGuestToUserSuccessActionType = ActionType<
    AuthActionTypes.MIGRATE_GUEST_TO_USER_SUCCESS,
    IMigrateGuestSuccess
>;
export type MigrateGuestToUserFailureActionType = ActionType<
    AuthActionTypes.MIGRATE_GUEST_TO_USER_FAILURE,
    IMigrateGuestFailure
>;

export type SetUserTokenActionType = ActionType<AuthActionTypes.SET_USER_TOKEN, ISetUserToken>;
export type SetLoadingActionType = ActionType<AuthActionTypes.SET_LOADING, ISetLoadingData>;
export type ClearErrorsActionType = ActionType<AuthActionTypes.CLEAR_ERRORS, IClearErrorsData>;
